<template>
<div class="chapter">
<div class="inner_page">
<div class="ack" id="ack-1">
<p class="centerImage"><img alt="images" id="img9" src="images/img9.jpg" style="max-width:100%;"/></p>
<p class="caption"><em class="italic">The Idle Apprentice executed at Tyburn, as depicted by William Hogarth (1697–1764)</em> <span class="fontS">Author’s collection</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07a_Fouldeeds_ack1.vue?fa0f4648